/**
 * COMMAND-CENTER-000001 — Founder Decision Board contracts.
 * Product answers: "What should I do next?" (not "What happened?").
 */

export type ActionPriority = 'critical' | 'important' | 'opportunity' | 'information';

export type BusinessArea =
  | 'connect'
  | 'orders'
  | 'inventory'
  | 'sync'
  | 'pricing'
  | 'finance'
  | 'fulfillment'
  | 'catalog'
  | 'other';

/** Certified LIVE action only — never invent fields at render time. */
export type DecisionAction = {
  id: string;
  priority: ActionPriority;
  businessArea: BusinessArea;
  title: string;
  description: string;
  evidence: string;
  confidence: number;
  createdAt: string;
  updatedAt: string;
  sourceWorkspace: string;
  workspacePath: string;
  quickActionLabel: string;
  sellerId?: string;
  sellerLabel?: string;
  marketplace?: string;
};

export type BoardViewMode = 'active' | 'pinned' | 'bookmarks' | 'completed';

export type SortMode = 'updated_desc' | 'confidence_asc' | 'confidence_desc';

export type DecisionFiltersState = {
  priority: ActionPriority | 'all';
  workspace: string | 'all';
  businessArea: BusinessArea | 'all';
  dateFrom: string;
  dateTo: string;
  seller: string | 'all';
  marketplace: string | 'all';
  search: string;
};

export type LocalActionFlags = {
  completed: string[];
  dismissed: string[];
  bookmarked: string[];
  pinned: string[];
};

export type CommandCenterModel = {
  loadedAt: string;
  connectionId: string | null;
  sellerRef?: string;
  marketplace?: string;
  actions: DecisionAction[];
  truncated: boolean;
  error: string | null;
  sourceNote: string;
};

export const PRIORITY_ORDER: readonly ActionPriority[] = [
  'critical',
  'important',
  'opportunity',
  'information',
] as const;

export const PRIORITY_LABEL: Record<ActionPriority, string> = {
  critical: 'Critical',
  important: 'Important',
  opportunity: 'Opportunity',
  information: 'Information',
};

export const EMPTY_BOARD_MESSAGE =
  'No business actions currently require attention.';
